var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenPrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 24,
    viewBox: "0 0 99 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.3274 16.9476C33.5318 16.9476 31.5273 14.9302 31.5273 12.0955C31.5273 9.22597 33.5845 7.20862 36.4329 7.20862C38.279 7.20862 39.9142 8.13034 40.6351 9.60857L39.7736 10.0955C39.1406 8.93032 37.8922 8.16512 36.4329 8.16512C34.2175 8.16512 32.5823 9.78248 32.5823 12.0955C32.5823 14.3737 34.1647 15.9911 36.3274 15.9911C37.7867 15.9911 39.123 15.1737 39.7208 14.0607L40.5824 14.5824C39.8263 16.0258 38.156 16.9476 36.3274 16.9476Z",
    fill: "#1C8578"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.327 16.965C43.4963 16.965 41.4391 14.8085 41.4391 12.0781C41.4391 9.3651 43.4963 7.20862 46.327 7.20862C49.1578 7.20862 51.215 9.3651 51.215 12.0781C51.215 14.8085 49.1578 16.965 46.327 16.965ZM46.327 16.0084C48.5424 16.0084 50.16 14.2694 50.16 12.0781C50.16 9.90422 48.5424 8.16512 46.327 8.16512C44.1292 8.16512 42.494 9.90422 42.494 12.0781C42.494 14.2694 44.1292 16.0084 46.327 16.0084Z",
    fill: "#1C8578"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0653 7.20862H62.0719L57.9049 16.7215H55.7422L51.5927 7.20862H54.6345L56.8675 13.052L59.0653 7.20862Z",
    fill: "#204047"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1537 6.23472C63.2218 6.23472 62.5009 5.53908 62.5009 4.61736C62.5009 3.69564 63.2394 3 64.1537 3C65.0856 3 65.8064 3.69564 65.8064 4.61736C65.8064 5.53908 65.0856 6.23472 64.1537 6.23472ZM65.5251 16.7389H62.7647V7.20862H65.5251V16.7389Z",
    fill: "#204047"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1286 3.50434H76.8891V16.7389H74.2165V15.7128C73.566 16.4432 72.6517 16.9823 71.3506 16.9823C68.6604 16.9823 66.6033 14.8606 66.6033 11.9737C66.6033 9.10423 68.6604 6.96514 71.3506 6.96514C72.5989 6.96514 73.4781 7.46948 74.1286 8.13034V3.50434ZM71.8077 14.4954C73.2671 14.4954 74.2693 13.365 74.2693 11.9564C74.2693 10.5825 73.2671 9.45205 71.8077 9.45205C70.3484 9.45205 69.3462 10.5825 69.3462 11.9564C69.3462 13.365 70.3484 14.4954 71.8077 14.4954Z",
    fill: "#204047"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9786 11.7477C87.9786 12.1303 87.9434 12.5129 87.8907 12.8955H80.8049C81.1038 13.9389 81.9302 14.6867 83.4247 14.6867C84.4621 14.6867 85.6577 14.2867 86.4313 13.765L87.5214 15.6258C86.5896 16.3215 85.095 16.9476 83.3016 16.9476C79.6972 16.9476 78.0269 14.5476 78.0269 11.9564C78.0269 9.12162 80.0489 6.96514 83.1082 6.96514C85.8687 6.96514 87.9786 8.72163 87.9786 11.7477ZM83.1082 9.1738C81.9829 9.1738 81.1038 9.83465 80.7873 10.9477H85.3236C85.0775 9.86944 84.2687 9.1738 83.1082 9.1738Z",
    fill: "#204047"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7779 16.9997C90.6658 16.9997 88.5911 14.7389 88.5911 11.9737C88.5911 9.20858 90.6658 6.94775 93.7779 6.94775C96.9076 6.94775 99 9.20858 99 11.9737C99 14.7389 96.9076 16.9997 93.7779 16.9997ZM93.7779 14.4607C95.167 14.4607 96.2395 13.365 96.2395 11.9564C96.2395 10.5825 95.167 9.48683 93.7779 9.48683C92.4065 9.48683 91.334 10.5825 91.334 11.9564C91.334 13.365 92.4065 14.4607 93.7779 14.4607Z",
    fill: "#204047"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.573 18.7127V5.19404L6.2479 1.82031L0 8.00003V15.9989L6.2479 22.2202L11.573 18.7127Z",
    fill: "#1C8578"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4474 11.8006L26.7082 11.765V7.99886L18.6684 0H8.07801L6.23828 1.81914L18.4474 11.8006Z",
    fill: "url(#paint0_linear_2160_111474)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4474 11.8013L6.23828 22.2197L8.02724 24.0002H18.6684L26.7082 15.9984V11.7656L18.4474 11.8013Z",
    fill: "#11A694"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2160_111474",
    x1: 14.0219,
    y1: 1.25307,
    x2: 20.9254,
    y2: 11.6476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0483,
    stopColor: "#11A694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2FE0C7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenPrimary);
export default __webpack_public_path__ + "static/media/green-primary.fa73d6c8f0295e82ff532fb4357a5603.svg";
export { ForwardRef as ReactComponent };